var r = /* @__PURE__ */ ((I) => (I.Disclaimer = "DISCLAIMER", I.PrivacyPolicy = "PRIVACYPOLICY", I.Terms = "TERMS", I.CookiePolicy = "COOKIEPOLICY", I.EditorialPolicy = "EDITORIALPOLICY", I.EmailPolicy = "EMAILPOLICY", I))(r || {});
export {
  r as PolicyDialogType
};
//# sourceMappingURL=index4.js.map
